import { createFileRoute, Outlet } from "@tanstack/react-router";
import { SignupContext } from "../components/SignupContext";
import { useGetter } from "^/common/useGetter";

export const Route = createFileRoute("/sign-up")({
  component: RouteComponent,
});
function RouteComponent() {
  const [getInfo, setInfo] = useGetter();
  return (
    <SignupContext.Provider value={{ setInfo, getInfo }}>
      <Outlet />
    </SignupContext.Provider>
  );
}
